export interface ApprovalWorkflow {
  id: string;
  orgId: number;
  code: string;
  name: string;
  flow: string;
  nativeName: string;
  description: string;
  nativeDescription: string;
  totalLevel: number;
  status: number;
  details: Detail[];
}

export interface ApprovalWorkflowShort {
  id: string;
  orgId: number;
  code: string;
  name: string;
  nativeName: string;
}

export interface ApprovalWorkflowListRequest {
  id?: string | null;
  code?: string | null;
  name?: string | null;
  select?: string[] | null;

  flow?: string | null;

  page?: number;
  limit?: number;
  keyword?: string | null;
  status?: number | null;
}

export interface ApprovalWorkflowCreateRequest {
  code: string;
  name: string;
  nativeName?: string;
  description?: string;
  nativeDescription?: string;
  flow?: string;
  status: number;
  details?: Detail[];
}

interface Detail {
  level: number;
  approveType: string;
  sla: number;
  nextAction: string;
}

export interface ApprovalWorkflowUpdateRequest
  extends ApprovalWorkflowCreateRequest {
  id: string;
}

export interface ApprovalWorkflowListResponse extends RestAPIMetaResponse {
  items: Array<ApprovalWorkflow>;
}

export interface ApprovalWorkflowListShortResponse extends RestAPIMetaResponse {
  items: Array<ApprovalWorkflowShort>;
}

export enum ApprovalWorkFlowData {
  PAYROLL_SHEET = "PAYROLL_SHEET",
  PAYROLL_UNLOCK = "PAYROLL_UNLOCK",
  OT = "OT",
  LEAVE = "LEAVE",
  SALARY_ADVANCE = "SALARY_ADVANCE",
  SALARY_PAYMENT = "SALARY_PAYMENT",
  PRODUCTIVITY_SALARY = "PRODUCTIVITY_SALARY",
  SUMMARY_PRODUCTIVITY_SALARY = "SUMMARY_PRODUCTIVITY_SALARY",
  SALARY_13TH_MONTH = "PAYROLL_13TH",
  KPI_INDIVIDUAL = "KPI_INDIVIDUAL",
  KPI_DEPARTMENT = "KPI_DEPARTMENT",
}

export enum ApprovalWorkFlowType {
  ONE = "ONE",
  ALL = "ALL",
}
export enum ApprovalWorkFlowNextAction {
  AUTO_APPROVE = "AUTO_APPROVE",
  AUTO_REJECT = "AUTO_REJECT",
  REMIND = "REMIND",
}
